import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {ResetPasswordService} from 'src/app/services/reset-password/reset-password.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {ResetPassword} from '../../shared/common-components/common-structure';
import {LoadingService} from '../../services/loading/loading.service';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../services/user/user.service';
import AppConstants from '../../shared/common-components/AppConstants';
import {User} from '../../services/user/user';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  resetPasswordForm: UntypedFormGroup;
  errorMessage: string = null;
  successMessage: string = null;
  alertService: any;
  currentUser: User | any;
  private user_subscription: Subscription;

  constructor(private fb: UntypedFormBuilder,
              private loggerService: LoggerService,
              private resetPasswordSerivce: ResetPasswordService,
              private tmssLoader: LoadingService,
              private userService: UserService,
              private route: ActivatedRoute) {
    this.user_subscription = this.userService.getCurrentUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        // removes user from session table
        this.userService.removeSession(this.currentUser);
      }
    }, (error1) => {
      this.alertService.info('unable to get current user details');
    });
    const passwordFormControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
    this.resetPasswordForm = this.fb.group({
      password: passwordFormControl,
      confirmPassword: new UntypedFormControl('', [Validators.required, CommonValidators.same(passwordFormControl)]),
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email]),
      otpCode: new UntypedFormControl('', Validators.required),
      secretQuestion: new UntypedFormControl('', Validators.required),
      secretAnswer: new UntypedFormControl('', Validators.required),
    });
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.tmssLoader.show();
        this.loggerService.log('getting user details...');
        this.tmssLoader.show();
        this.loggerService.log('received email parameter', params['email']);
        this.resetPasswordForm.get('email').setValue(params['email']);

        const email: string = params['email'];
        this.resetPasswordSerivce.getUserQuestion(email).subscribe(
            response => {
              this.loggerService.log('response from question api is ', response);
              if (response && response.question) {
                this.resetPasswordForm.get('secretQuestion').setValue(response.question);
                this.errorMessage = null;
                this.tmssLoader.hide();
              }
              if (!response.question) {
                this.errorMessage = 'Invalid question. Please contact support if the issue persists.';
              }
            },
            error => {
              this.loggerService.log('error from question api is ', error);
              this.errorMessage = error.error;
              this.tmssLoader.hide();
            }
        );
        this.tmssLoader.hide();
      }
    });


  }

  ngOnInit() {
  }

  submitRequest() {
    this.errorMessage = '';
    this.loggerService.log('submitted resetPassword request');
    this.loggerService.log('the resetPasswordForm is ', this.resetPasswordForm);
    const resetPassword: ResetPassword = new ResetPassword();
    resetPassword.password = this.resetPasswordForm.get('password').value;
    resetPassword.email = this.resetPasswordForm.get('email').value;
    resetPassword.otpCode = this.resetPasswordForm.get('otpCode').value;
    resetPassword.secretQuestion = this.resetPasswordForm.get('secretQuestion').value;
    resetPassword.secretAnswer = this.resetPasswordForm.get('secretAnswer').value;

    if (!this.isValidPassword(resetPassword.password)) {
      this.errorMessage = 'The password does not meet the minimum requirements. Please revise your password and try again.';
      return;
    }

    this.tmssLoader.show();
    this.resetPasswordSerivce.create(resetPassword).subscribe(response => {
          this.loggerService.log('got a response ', response);
          this.tmssLoader.hide();
          this.errorMessage = null;
          this.successMessage = 'Password successfully updated';
          this.userService.logout('reset password');

        },
        err => {
          this.tmssLoader.hide();
          this.loggerService.log('got an error response ', err);
          this.errorMessage = err.error.error;
          this.successMessage = null;
        });

  }

  isValidPassword(password) {
    const baseRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

    return baseRegex.test(password);
  }

  ngOnDestroy(): void {
    if (this.user_subscription) {
      this.user_subscription.unsubscribe();
    }
  }

}
